import { useContext, useEffect, useState } from 'react'
import { XCircle, CheckCircle } from '@styled-icons/boxicons-solid'

import Button from '../../../../common/Button'
import { getRequest, postRequest } from '../../../../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../../../../context/global_context'
import FileField from '../../../../common/FileField'
import SelectInput from '../../../../common/SelectInput'
import useDebouncedValue from '../../../../../utils/common_function'

const DEFAULT_PAYLOAD = {
  sales_code_file: '',
  name: '',
}

const SalesCodeComplexityForm = (props) => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(NavContext)

  const [data, setData] = useState([{ ...DEFAULT_PAYLOAD, id: Math.random() }])
  const [error, setError] = useState([])
  const [harnessOptions, setHarnessOptions] = useState([])
  const [loader, setLoader] = useState(false)

  const [searchHarness, setSearchHarness] = useState('')
  const debouncedToSearchHarness = useDebouncedValue(searchHarness, 1000)

  const submitSalesCodeFiles = async (e) => {
    dispatch({
      type: 'loader',
      data: {
        caption: `Sales Code File upload is in progress, Don't Refresh Or close Window`,
        showLoader: true,
      },
      notification: {},
    })
    const form = e.target
    const formData = new FormData(form)
    let res = await postRequest(
      `/api/plugin/sales_code/upload/${vehicle}/`,
      formData,
      false,
      {
        onUploadProgress: (progressEvent) => {
          uploadProgressFunction(progressEvent)
        },
      }
    )
  }

  const setSelectedObjValue = (field_name, value, index) => {
    let selectedArray = [...data]
    selectedArray[index][field_name] = value
    setData(selectedArray)
  }

  const removeSelected = (index) => {
    let temp = [...data]
    temp.splice(index, 1)
    setData(temp)
  }

  const uploadProgressFunction = (progressEvent) => {
    const totalLength = progressEvent.lengthComputable
      ? progressEvent.total
      : progressEvent.target.getResponseHeader('content-length') ||
        progressEvent.target.getResponseHeader('x-decompressed-content-length')

    const percentageCompleted = Math.round(
      (progressEvent.loaded * 100) / totalLength
    )
    if (percentageCompleted === 100) {
      dispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
      setData([])
    }
  }

  const getHarnessData = async (searchValue) => {
    setHarnessOptions([])
    setLoader(true)
    let res = await getRequest(
      `/api/harnesses/?vehicle=${vehicle}&search=${searchValue}&limit=50`
    )
    setHarnessOptions(res.results)
    setLoader(false)
  }

  useEffect(() => {
    getHarnessData(searchHarness)
  }, [debouncedToSearchHarness])

  return (
    <>
      {data?.length < 1 && Object.keys(error)?.length < 1 ? (
        <div className="flex items-center justify-center  text-green-500">
          <div className="text-center">
            <CheckCircle
              className={'text-green-500 mr-3 cursor-pointer'}
              size="2rem"
            />
            <div>
              <div className="text-2xl">
                Sales Code Complexity Files Successfully Uploaded
              </div>
              <div>
                **We are processing files, so check status. Will Let you know
                once Process completed
              </div>
            </div>
          </div>
        </div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault()
            submitSalesCodeFiles(e)
          }}
        >
          <input type="hidden" value={data.length} name={`total_files`} />
          {data.map((value, index) => {
            return (
              <div key={`${index}-sales-code-${value.id}}`}>
                <div className="flex">
                  <div className="w-4/12 flex">
                    <SelectInput
                      value={value.name}
                      onChange={(value) => {
                        setSelectedObjValue('name', value, index)
                      }}
                      key={`${index}-name`}
                      label="Harness"
                      name={`${index}-name`}
                      isRequired={false}
                      options={harnessOptions}
                      onInputChange={(value) => {
                        setSearchHarness(value)
                      }}
                      formatOptionLabel={(option) => (
                        <>
                          <div className="font-extrabold">
                            {option.harness_id}
                          </div>
                        </>
                      )}
                      optionLabel={'harness_id'}
                      optionValue={'id'}
                      isClearable={true}
                      showLoader={loader}
                    />
                  </div>
                  <div className="w-6/12">
                    <FileField
                      key={`${index}-sales_code_file`}
                      label="Sales Code File"
                      name={`${index}-sales_code_file`}
                      isRequired={true}
                      onChange={(e) => {
                        setSelectedObjValue(
                          'sales_code_file',
                          e.target.value,
                          index
                        )
                      }}
                      value={value.def_file}
                    />
                  </div>

                  <div className="w-2/12 text-white flex items-center">
                    {index != 0 && data.length - 1 == index && (
                      <XCircle
                        className={'text-red-500 mr-3 cursor-pointer'}
                        size="2rem"
                        onClick={() => {
                          removeSelected(index)
                        }}
                      />
                    )}
                  </div>
                </div>
                {value?.error && (
                  <div className="flex justify-end text-red-700">
                    {value.error}
                  </div>
                )}
              </div>
            )
          })}
          <div className="flex justify-end text-blue-100">
            <span
              onClick={() => {
                let tempData = [...data]
                tempData.push({ ...DEFAULT_PAYLOAD, id: Math.random() })
                setData(tempData)
              }}
              className="underline cursor-pointer"
            >
              {' '}
              Add More Files
            </span>
          </div>

          <div className="flex justify-end">
            <div className="w-1/4">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 w-full justify-end`}
                onClick={(e) => {}}
                value={'text'}
                text={'Save Sales Code Files'}
              />
            </div>
          </div>
        </form>
      )}
    </>
  )
}

export default SalesCodeComplexityForm
